// extracted by mini-css-extract-plugin
export default {"linkLabel":"LinkLabel_linkLabel__a8tYa"};